import setWinnerDialogDialog from './setWinnerDialog.container'

export default setWinnerDialogDialog